import React,{ useState, useEffect } from 'react'
import Form from './Form'
import useSubscribers from '../../hooks/useSubscribers'
import { useForm } from 'react-hook-form'
import { subscribersInfoField } from '../../pages/types'
import { josa } from 'josa'

export type SubscriberFieldsetProps = {
  field : subscribersInfoField
  onSubmit?: any
  form?: JSX.Element
  listId: string
  changeEmailInUrl: () => void
  oldEmail?: string
}

export type subscriberFieldsetForm = {
  email: string
  name: string
  phone_number: string
}

/** `SubscriberFieldset` */
function SubscriberFieldset(props : SubscriberFieldsetProps){

  // const { register, handleSubmit, errors, setError, clearErrors } = useForm()
  const { field, listId, changeEmailInUrl, oldEmail} = props
  const { label, value, substitution, customLabel } = field
  const [ isShow, setIsShow ] = useState(false)
  const { subscribersInfo, updateSubscriber } = useSubscribers()

  //set default value
  const [ defaultValues, setDefaultValues ] = useState({})
  defaultValues[substitution] = value
  const methods = useForm<subscriberFieldsetForm>({ defaultValues });
  const { errors, register, setError } = methods

  useEffect(()=>{
    if(subscribersInfo.status==='success'){
      if(substitution==='email'&&value!== oldEmail){
        changeEmailInUrl()
      }
      setIsShow(false)
      setDefaultValues(defaultValues)

    }else if(substitution==='email'&&subscribersInfo.status==='failure'&& subscribersInfo.errorData?.response?.data.Code==="Errors.List.AlreadyExistEmail"){
      setError('email',{type:'duplicated'})
    }
  },[subscribersInfo])

  const onSubmit = async (data)=>{

    if(substitution===('email'||'phone_number'||'name')){
      const updateSubscriberBody = {
        listId: listId,
        subscriber: subscribersInfo.data.email,
        requestBody: data
      }
      updateSubscriber(updateSubscriberBody)
    }else{
      const updateSubscriberBody = {
        listId: listId,
        subscriber:subscribersInfo.data.email,
        requestBody:{subscriber:data}
      }
      updateSubscriber(updateSubscriberBody)
    } 
  }

  const onError = (errors, e) =>{
    console.log(errors, e)
  }

  const handleClickUpdateShowBtn = () =>{
    // reset()
    setIsShow(!isShow)
  }
  
  const onClickCancelButton = (e:React.MouseEvent<HTMLButtonElement, MouseEvent>) => {
    // reset()
    e.preventDefault();
    e.stopPropagation();
    setIsShow(!isShow)
  }

  const emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

  const fieldForm = (v:subscribersInfoField) =>{
    if(v.substitution === 'email'){
      return(
        <>
          <input className="stb_form_set_input" name={v.substitution} ref={register({required:true, pattern: emailPattern})} />
          {errors.email?.type === 'required' && <div className="stb_form_msg_error">이메일 주소를 입력하세요.</div>}
          {errors.email?.type === 'pattern' && <div className="stb_form_msg_error">올바른 이메일 주소를 입력하세요.</div>}
          {errors.email?.type === 'duplicated' && <div className="stb_form_msg_error">이미 존재하는 이메일 입니다.</div>}
        </>
      )
    }else if(v.substitution !== 'email' && v.isMandatory){
      return(
        <>
          <input className="stb_form_set_input" name={v.substitution} ref={register({required:true})} />
          {errors.hasOwnProperty(v.substitution) && <div className="stb_form_msg_error">{josa(`${v.label}#{을}`)} 입력하세요.</div>}
        </>
      )
    }else{
      return(
        <>
          <input className="stb_form_set_input" name={v.substitution} ref={register}/>
        </>
      )
    }
  }

  return (
    <>
    <div className="stb_form_set field">
      <label className="stb_subscriber_info_label">{customLabel?customLabel:label}</label><br/>
      {isShow?
        <>
          <Form onSubmit={onSubmit} onError={onError} methods={methods}>
            {fieldForm(field)}
            <button type="submit" className="stb_form_submit_button btn secondary">저장하기</button>
            <button className="stb_form_submit_button btn white" onClick={(e)=>onClickCancelButton(e)}>취소</button>
          </Form>
        </>
        :
        <>
        <span className="update_show_btn" onClick={handleClickUpdateShowBtn}>변경하기</span>
          <p>{value?value:'-'}</p>
        </>
      }
    </div>
    </>
  ) 
}

export default SubscriberFieldset;